import { FeatureTriggerState, MLFeatureCondition, MLFeatureType } from './types';

function createFeatureRingBuffer(criteriaWindow: number) {
  const size = Number.isFinite(criteriaWindow) ? Math.max(Math.floor(criteriaWindow), 0) : 0;
  return {
    buffer: new Array(size).fill(false),
    writeIndex: 0,
    trueCount: 0,
    filledCount: 0,
  };
}

export function createFeatureTriggerState(
  featureType: MLFeatureType,
  condition: MLFeatureCondition
): FeatureTriggerState {
  return {
    featureType,
    condition,
    ring: createFeatureRingBuffer(condition.criteriaWindow),
    triggeredAt: null,
  };
}

/**
 * Ring buffer에 새 추론 결과를 기록하고 trigger 여부를 O(1)로 판정한다.
 * state.ring을 in-place로 갱신한다 — 외부 구독자가 없으므로 immutability 불필요.
 */
export function evaluateFeature(state: FeatureTriggerState, result: number[]): boolean {
  const { condition, ring } = state;
  const windowSize = ring.buffer.length;

  if (condition.modelIndex < 0 || condition.modelIndex >= result.length) {
    return false;
  }

  if (windowSize <= 0) {
    return false;
  }

  const exceed = result[condition.modelIndex] >= condition.threshold;

  const oldest = ring.buffer[ring.writeIndex];
  ring.buffer[ring.writeIndex] = exceed;
  ring.writeIndex = (ring.writeIndex + 1) % windowSize;

  if (ring.filledCount >= windowSize && oldest) {
    ring.trueCount--;
  }
  if (exceed) {
    ring.trueCount++;
  }
  if (ring.filledCount < windowSize) {
    ring.filledCount++;
  }

  return ring.trueCount >= condition.criteriaThreshold;
}
